import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { ProductImage } from "@/components/shop/ProductImage";

export const ImageUpload = ({ value, onChange, label = "Foto prodotto", testid = "pf-image" }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) return toast.error("Immagine troppo grande (max 8 MB)");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Foto caricata");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-1 sm:col-span-2">
      <span className="text-xs text-stone-600">{label}</span>
      <div className="flex items-center gap-3">
        <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-black/10 bg-[#FFFBF3]">
          {value ? <ProductImage src={value} alt="Anteprima" w={300} width={80} height={80} className="h-full w-full object-contain" testid={`${testid}-preview`} /> : <ImagePlus className="h-6 w-6 text-stone-400" />}
        </div>
        <button type="button" disabled={busy} onClick={() => input.current?.click()} className="flex items-center gap-2 rounded-full border-2 border-black px-4 py-2 text-sm font-semibold disabled:opacity-50" data-testid={`${testid}-upload`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}{busy ? "Caricamento..." : value ? "Cambia foto" : "Carica foto"}
        </button>
        {value && testid !== "pf-image" && <button type="button" onClick={() => onChange(null)} className="text-xs text-rose-600 underline" data-testid={`${testid}-remove`}>Rimuovi</button>}
        <input ref={input} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={pick} className="hidden" data-testid={`${testid}-file`} />
      </div>
    </div>
  );
};
